import { Field, Form, Formik } from "formik";
import { lotterySchema } from "../../yupSchema/lotterySchema";
import { useIntl } from "react-intl";
import { useEffect, useRef, useState } from "react";
import {
  LotteryHLCompanyConst,
  LotteryMKTCompanyConst,
} from "../../../../constants/LotteryCompanyConst";
import { CheckIsNull, toAbsoluteUrl } from "../../../../utils/CommonHelper";
import { Input } from "../../../common/components/control/InputField";
import { LotteryTypeConst } from "../../../../constants/LotteryNavConst";

const BetTypeConst = ["Box", "IBox"];

export const LotteryBetForm = ({ saveValues, lotteryType }) => {
  const intl = useIntl();
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [betType, setBetType] = useState("");
  const bigRef = useRef();

  useEffect(() => {
    setSelectedCompany([]);
  }, [lotteryType]);

  const PermAlone = (str) => {
    let arr = str.split("");
    let reg = /(.)\1+/; //regexp for repeating characters
    let perms = 0;
    function swap(indexFrom, indexTo, arr) {
      if (indexTo === arr.length - 1) {
        let enterStr = arr.join("");
        if (!reg.test(enterStr)) perms++;
      } else {
        let newArr = []; //newArr(copy of arr) is needed so that not to modify the original one, as next calls of swap() need it
        for (let i = 0; i < arr.length; i++) {
          newArr.push(arr[i]);
        }
        let temp = newArr[indexFrom];
        newArr[indexFrom] = newArr[indexTo];
        newArr[indexTo] = temp;

        for (let i = indexTo + 1; i < arr.length; i++) {
          swap(i, indexTo + 1, newArr);
        }
      }
    }
    //start recursion
    for (let i = 0; i < arr.length; i++) {
      swap(i, 0, arr);
    }

    return perms;
  };

  const GetNumDiffer = (numDiffers) => {
    let countDiffer = 0;
    for (const numDiffer in numDiffers) {
      if (numDiffers.hasOwnProperty(numDiffer)) {
        ++countDiffer;
      }
    }
    return countDiffer;
  };

  const BoxMultiply = (value) => {
    const arr = !CheckIsNull(value) ? value.toString().split("") : [];
    let numDiffers = {};
    let totalBox = 0;

    for (let i = 0; i < arr.length; i++) {
      numDiffers[arr[i]] = 1 + (numDiffers[arr[i]] || 0);
    }
    let countDiffer = GetNumDiffer(numDiffers);
    if (countDiffer === 2) {
      totalBox = PermAlone(value.toString());
      if (totalBox === 0) totalBox = 4;
      if (totalBox === 8) totalBox = 6;
    } else {
      if (countDiffer === 1) totalBox = 1;
      else if (countDiffer === 3) totalBox = 12;
      else totalBox = 24;
    }

    return totalBox;
  };

  return (
    <>
      <Formik
        initialValues={{
          number: "",
          big: 0,
          small: 0,
          fourA: 0,
        }}
        validationSchema={lotterySchema(intl)}
        enableReinitialize={true}
        onSubmit={(values, formikHelpers) => {
          if (selectedCompany.length > 0) {
            const subTotal =
              (parseFloat(values.big ? values.big : 0) +
                parseFloat(values.small ? values.small : 0) +
                parseFloat(values.fourA ? values.fourA : 0)) *
              (betType === BetTypeConst[0] ? BoxMultiply(values.number) : 1) *
              selectedCompany.length;

            const companyList = selectedCompany
              .map((company) => company.lotteryKeyCode)
              .join("");

            const longCode = {
              key: Date.now(),
              companyList: selectedCompany,
              number: values.number,
              big: values.big,
              small: values.small,
              fourA: values.fourA,
              betType,
              subTotal,
              code: `#${companyList}|${
                betType === BetTypeConst[0]
                  ? "*"
                  : betType === BetTypeConst[1]
                  ? "**"
                  : ""
              }${values.number}#${values.big}#${values.small}#${values.fourA}`,
            };

            saveValues(longCode);
            setBetType("");
            formikHelpers.resetForm();
          }
        }}
      >
        {({
          values,
          handleSubmit,
          setFieldValue,
          touched,
          errors,
          setFieldError,
          setFieldTouched,
        }) => (
          <Form>
            <div className="mb-2">
              <label className="mb-2 text-input-label text-font3">
                {intl.formatMessage({ id: "chooseCompany" })}
              </label>
              <div className="d-flex align-items-center w-100">
                {(lotteryType === LotteryTypeConst.HL_LOTTERY
                  ? LotteryHLCompanyConst
                  : LotteryMKTCompanyConst
                ).map((lotteryCompany, index) => (
                  <div
                    className={`d-flex flex-column align-items-center justify-content-center overflow-scroll text-font2 ${
                      index === 0 ? "me-1" : "mx-1"
                    } py-2 px-1 rounded cursor-pointer ${
                      selectedCompany.filter(
                        (company) =>
                          company.lotteryCode === lotteryCompany.lotteryCode
                      ).length > 0
                        ? "text-dark"
                        : ""
                    }`}
                    key={index}
                    style={{
                      width: "45px",
                      userSelect: "none",
                      background:
                        selectedCompany.filter(
                          (company) =>
                            company.lotteryCode === lotteryCompany.lotteryCode
                        ).length > 0
                          ? "#d1ffbd"
                          : "rgba(255, 255, 255, 0.1)",
                    }}
                    onClick={() => {
                      if (
                        selectedCompany.filter(
                          (company) =>
                            company.lotteryCode === lotteryCompany.lotteryCode
                        ).length > 0
                      ) {
                        setSelectedCompany(
                          selectedCompany.filter(
                            (company) =>
                              company.lotteryCode !== lotteryCompany.lotteryCode
                          )
                        );
                      } else {
                        setSelectedCompany([
                          ...selectedCompany,
                          lotteryCompany,
                        ]);
                      }
                    }}
                  >
                    <img
                      src={toAbsoluteUrl(lotteryCompany.lotteryUrl)}
                      alt={lotteryCompany.lotteryCode}
                      className="w-100"
                    />
                    <div className="mt-2 fw-bold">
                      {lotteryCompany.lotteryCode}
                    </div>
                  </div>
                ))}
              </div>
              {touched.number && selectedCompany.length <= 0 && (
                <div className="fv-plugins-message-container text-danger mt-1">
                  <div className="fv-help-block">
                    <span role="alert">
                      {intl.formatMessage({ id: "companyRequired" })}
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className="d-flex">
              <div className="col-12 me-3">
                <div className="mb-2 text-font3">
                  <Field
                    name="number"
                    labelClass="border-0"
                    component={Input}
                    placeholder={intl.formatMessage({ id: "number" })}
                    label={intl.formatMessage({ id: "number" })}
                    autoComplete="off"
                    type="number"
                    onKeyDown={(e) => {
                      if (
                        e.target.value.length >= 4 &&
                        !e.ctrlKey &&
                        !e.shiftKey &&
                        e.key !== "Backspace"
                      ) {
                        bigRef.current.focus();
                      }
                    }}
                  />
                </div>
                <div
                  className="d-flex align-items-center justify-content-between mb-2 text-font3"
                  style={{ gap: "0.5rem" }}
                >
                  <div className="flex-fill">
                    <Field
                      name="big"
                      labelClass="border-0"
                      component={Input}
                      placeholder={intl.formatMessage({ id: "big" })}
                      label={intl.formatMessage({ id: "big" })}
                      autoComplete="off"
                      type="number"
                      innerRef={bigRef}
                      onBlur={() => {
                        setFieldTouched("big", true);
                        setFieldTouched("small", true);
                        setFieldTouched("fourA", true);
                      }}
                      onKeyDown={(e) => {
                        if (
                          parseInt(values.big) === 0 &&
                          !e.ctrlKey &&
                          !e.shiftKey &&
                          e.key !== "Backspace"
                        ) {
                          setFieldValue("big", "");
                        }
                      }}
                    />
                  </div>
                  <div className="flex-fill">
                    <Field
                      name="small"
                      labelClass="border-0"
                      component={Input}
                      placeholder={intl.formatMessage({ id: "small" })}
                      label={intl.formatMessage({ id: "small" })}
                      autoComplete="off"
                      type="number"
                      onBlur={() => {
                        setFieldTouched("big", true);
                        setFieldTouched("small", true);
                        setFieldTouched("fourA", true);
                      }}
                      onKeyDown={(e) => {
                        if (
                          parseInt(values.small) === 0 &&
                          !e.ctrlKey &&
                          !e.shiftKey &&
                          e.key !== "Backspace"
                        ) {
                          setFieldValue("small", "");
                        }
                      }}
                    />
                  </div>
                  <div className="flex-fill">
                    <Field
                      name="fourA"
                      labelClass="border-0"
                      component={Input}
                      placeholder={intl.formatMessage({ id: "4a" })}
                      label={intl.formatMessage({ id: "4a" })}
                      autoComplete="off"
                      type="number"
                      onBlur={() => {
                        setFieldTouched("big", true);
                        setFieldTouched("small", true);
                        setFieldTouched("fourA", true);
                      }}
                      onKeyDown={(e) => {
                        if (
                          parseInt(values.fourA) === 0 &&
                          !e.ctrlKey &&
                          !e.shiftKey &&
                          e.key !== "Backspace"
                        ) {
                          setFieldValue("fourA", "");
                        }
                      }}
                    />
                  </div>
                </div>
                {(touched.big || touched.small || touched.fourA) &&
                  parseFloat(values.big ? values.big : 0) +
                    parseFloat(values.small ? values.small : 0) +
                    parseFloat(values.fourA ? values.fourA : 0) <=
                    0 && (
                    <div className="fv-plugins-message-container text-danger ">
                      <div className="fv-help-block">
                        <span role="alert">
                          {intl.formatMessage({ id: "sumMin1" })}
                        </span>
                      </div>
                    </div>
                  )}
              </div>
            </div>
            <div className="d-flex">
              <div className="col-7">
                <label className="mb-2 text-input-label text-font3">
                  {intl.formatMessage({ id: "betType" })}
                </label>
                <div className="d-flex" style={{ gap: "0.5rem" }}>
                  {BetTypeConst.map((bet, index) => (
                    <div
                      className={` cursor-pointer py-1 text-font3 rounded text-center ${
                        betType === bet
                          ? "bg-light-success text-dark fw-bold"
                          : "bg-hover"
                      }`}
                      style={{ width: "48%" }}
                      key={index}
                      onClick={() => {
                        if (betType === bet) {
                          setBetType("");
                        } else {
                          setBetType(bet);
                        }
                      }}
                    >
                      {bet}
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-5 d-flex flex-column ps-2">
                <div
                  className="p-2 text-end"
                  style={{
                    background: "rgba(255,255,255,0.2)",
                    borderRadius: "5px",
                  }}
                >
                  <label className="text-input-label text-font3">
                    {intl.formatMessage({ id: "estimatePrice" })}
                  </label>
                  <div className="fw-bold text-font3">
                    {CheckIsNull(values.number) ||
                    values.number.toString().length < 4
                      ? "0.00"
                      : parseFloat(
                          (parseFloat(values.big ? values.big : 0) +
                            parseFloat(values.small ? values.small : 0) +
                            parseFloat(values.fourA ? values.fourA : 0)) *
                            (betType === BetTypeConst[0]
                              ? BoxMultiply(values.number)
                              : 1) *
                            selectedCompany.length
                        ).toFixed(2)}
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end mt-2">
              <button
                type="submit"
                className="btn btn-prim px-4 py-1 text-font3"
              >
                {intl.formatMessage({ id: "add" })}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
